import React, { useCallback, useState } from "react";

import ConfirmModal from "../ConfirmModal";

const AdminUnlockPanel = ({ handleAction }: any) => {
  const [modalOpen, setModalOpen] = useState(false);
  const [message, setMessage] = useState("Are you sure?");
  const showModal = useCallback(
    (action: any, message: any, selectedStep?: any) => {
      console.log("showModal", action, message, selectedStep);
      setMessage(message);
      setModalOpen(true);
    },
    []
  );
  return (
    <div className="bg-white overflow-hidden shadow rounded-lg divide-y divide-gray-200 mb-8">
      <div className="px-4 py-5 sm:px-6 bg-gray-50">
        <h2 className="font-bold text-gray-700">Admin Unlock Controls</h2>
      </div>
      <div className="px-4 py-5 sm:p-6">
        <button
          title='This will revert the application back to "In Progress" but will not notify anyone'
          className="w-full bg-gradient-to-b from-gray-600 to-gray-700 hover:from-gray-500 hover:to-gray-600  inline-flex justify-center py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white focus:outline-none focus:ring-2 focus:ring-offset-2 disabled:opacity-50 focus:ring-gray-700"
          onClick={() =>
            showModal(
              "reset",
              "This will set the application to 'Deficiency Review' status temporarily to allow administrators to change the current step of the application but will not notify the applicant."
            )
          }
        >
          Unlock Application
        </button>
      </div>
      {modalOpen && (
        <ConfirmModal
          message={message}
          handleClose={() => {
            setModalOpen(false);
          }}
          handleAction={() => {
            handleAction("reroute");
          }}
        />
      )}
    </div>
  );
};

export default AdminUnlockPanel;
